import { render } from "./IVRFlowBuilderView.vue?vue&type=template&id=50a5e0ee&scoped=true"
import script from "./IVRFlowBuilderView.vue?vue&type=script&lang=js"
export * from "./IVRFlowBuilderView.vue?vue&type=script&lang=js"

import "./IVRFlowBuilderView.vue?vue&type=style&index=0&id=50a5e0ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a5e0ee"]])

export default __exports__